import { memo } from 'react';
import { isEmpty } from 'lodash/fp';
import { Input, NumberInput } from '@mews-commander/legacy-form';
import { formatExponential } from '../../helpers';

interface Props {
    exchangeRate: {
        conversionRateToDefault?: string | number;
        currencyCode?: string;
        isAccepted?: boolean;
        conversionDirection?: string;
        errors?: $TSFixMe[];
        touched?: $TSFixMe; // TODO: false
    };
    shouldComputeExchangeRate: boolean;
}

const ExchangeRateInput = ({
    // @ts-expect-error $TSFixMeError: Property 'conversionRate' does not exist on type '{ conversionRateToDefault?: string | number | undefined; currencyCode?...
    exchangeRate: { conversionRate, touched, errors },
    shouldComputeExchangeRate,
    ...other
}: Props) => {
    const value = shouldComputeExchangeRate ? formatExponential(1 / conversionRate) : formatExponential(conversionRate);

    const inputProps = {
        disabled: shouldComputeExchangeRate,
        value,
        errors,
        touched,
    };

    return !isEmpty(errors) && shouldComputeExchangeRate ? (
        // @ts-expect-error $TSFixMeError: Type '{ value: string; disabled: boolean; errors: any[] | undefined; touched: any; }' is not assignable to type 'Intrins...
        <Input {...other} {...inputProps} value="-" />
    ) : (
        <NumberInput {...other} {...inputProps} />
    );
};

export default memo(
    ExchangeRateInput,
    (
        // @ts-expect-error $TSFixMeError: Property 'conversionRate' does not exist on type '{ conversionRateToDefault?: string | number | undefined; currencyCode?...
        { exchangeRate: { conversionRate: prevValue, currencyCode: prevCurrencyCode } },
        // @ts-expect-error $TSFixMeError: Property 'conversionRate' does not exist on type '{ conversionRateToDefault?: string | number | undefined; currencyCode?...
        { exchangeRate: { conversionRate: nextValue, errors, currencyCode } }
    ) => prevValue === nextValue && currencyCode === prevCurrencyCode && isEmpty(errors)
);
